import { render, staticRenderFns } from "./buyersModal.vue?vue&type=template&id=79a8f89c&"
import script from "./buyersModal.vue?vue&type=script&lang=js&"
export * from "./buyersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports